module.exports = __webpack_public_path__ + "static/media/img_bisteca.9c80c81b.jpg";